import { AddIcon, DeleteIcon, EditIcon } from "@rothoblaas/design-system";
import type { ContextMenuAction } from "@rothoblaas/design-system";
import Icon from "../components/ui/Icon";
import { I18n } from "../hooks/useTranslations";

export const getDeleteAction = (
  i18n: I18n,
  onClick: () => void,
  separatorBefore = false,
  disabled?: boolean,
): ContextMenuAction => ({
  onClick,
  label: i18n.translation.common.delete,
  variant: "danger",
  icon: <Icon glyph={DeleteIcon} />,
  separatorBefore,
  disabled,
});

export const getAddAction = (label: string, onClick: () => void): ContextMenuAction => ({
  onClick,
  label,
  icon: <Icon glyph={AddIcon} />,
});

export const getEditAction = (i18n: I18n, onClick: () => void, separatorBefore = false): ContextMenuAction => ({
  onClick,
  label: i18n.translation.common.edit,
  icon: <Icon glyph={EditIcon} />,
  separatorBefore,
});
